// Import modules (or ensure they are included via <script> tags in order)
import { registerServiceWorker } from './pwa.js';
import { bootApp } from './bootloader.js';
import {showWelcomePanel} from './welcome.js'; // Ensure welcome.js is loaded

// Event listeners
window.addEventListener('DOMContentLoaded', async () => {
  console.log('[Main] DOMContentLoaded event fired');

  // Show welcome panel if applicable
  const action = await showWelcomePanel();
  console.log(`[Main] Welcome panel action: ${action}`);

  if (action === 'exit') {
    document.body.innerHTML = `
      <div style="text-align:center; padding:40px; font-family:Segoe UI">
        <h2>Thanks for visiting SamApp</h2>
        <p>You can now close this tab.</p>
      </div>
    `;
    return;
  }
 console.log('[Main] Welcome panel skipped or closed, continuing...');
 
	// PWA setup
  await registerServiceWorker();
  console.log('[Main] Service Worker registered');

  await bootApp();
  console.log('[Main] App bootstrapped successfully');
});
